/* eslint-disable camelcase */
/* eslint-disable react/jsx-no-useless-fragment */

'use client';

import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ListadoProductos from '../components/productos/ListadoProductos';

/* ---------- Catálogo de filtros (solo Hytera) ---------- */
const filters = [
  {
    id: 'hytera',
    name: 'Hytera',
    options: [
      {
        value: 'radios-portatiles',
        label: 'Radios Portátiles',
        categoria_id: 5,
        img: 'https://jumpseller.s3.eu-west-1.amazonaws.com/store/radioclub/assets/bp51x_en_Digital_and_Analog_Compatible.jpg_n.webp',
        info: {
          title: 'Radios portátiles profesionales',
          description:
            'Comunicación instantánea de mano a mano para cuadrillas, seguridad y rescate. Diseñadas para soportar entornos hostiles con audio claro y autonomía de jornada completa.',
          bullets: [
            'Audio nítido con cancelación de ruido por IA',   // :contentReference[oaicite:0]{index=0}
            'Protección IP67/MIL-STD contra polvo, agua y golpes',   // :contentReference[oaicite:1]{index=1}
            'Más de 20 h de operación continua',   // :contentReference[oaicite:2]{index=2}
          ],
        },
      },
      {
        value: 'radios-moviles',
        label: 'Radios Móviles',
        categoria_id: 6,
        img: 'https://img-cdn.hytera.com/iwov-resources/hytera/17_campaign/hm68x_Highlights_5(1).jpg_n.webp',
        info: {
          title: 'Radios móviles vehiculares',
          description:
            'Solución fija para ambulancias, camiones y maquinaria. Potencia sobrada, posicionamiento integrado y audio impecable incluso a gran velocidad.',
          bullets: [
            'Cobertura extendida con hasta 45 W de salida',   // :contentReference[oaicite:3]{index=3}
            'GPS y Bluetooth para despacho, manos libres y OTA',   // :contentReference[oaicite:4]{index=4}
            'AI Noise-Cancellation para cabinas ruidosas',   // :contentReference[oaicite:5]{index=5}
          ],
        },
      },
      {
        value: 'repetidoras',
        label: 'Repetidoras',
        categoria_id: 7,
        img: 'https://img-cdn.hytera.com/iwov-resources/hytera/17_campaign/HR106X_Highlights-1.jpg_n.webp',
        info: {
          title: 'Repetidoras DMR',
          description:
            'Multiplica el alcance de tu red y mantén la voz clara en operaciones dispersas o subterráneas. Ideal para plantas industriales, minas y cobertura municipal.',
          bullets: [
            'Alcance > 50 km y enlace IP en cadena',   // :contentReference[oaicite:6]{index=6}
            'Chasis ultra-delgado 1U para rack estándar',   // :contentReference[oaicite:7]{index=7}
            'Modo analógico/digital con dos canales TDMA',   // :contentReference[oaicite:8]{index=8}
          ],
        },
      },
      {
        value: 'accesorios',
        label: 'Accesorios',
        categoria_id: 8,
        img: 'https://img-cdn.hytera.com/es_PE/iwov-resources/hytera/02_products/11_landing_page/en_portfolio_smart_accessories.jpg_n.webp',
        info: {
          title: 'Accesorios originales Hytera',
          description:
            'Complementa tus radios con periféricos certificados que cuidan la ergonomía y garantizan la operación 24/7.',
          bullets: [
            'Cargadores múltiples de 6 posiciones para flotas',   // :contentReference[oaicite:9]{index=9}
            'Auriculares ECN21 con atenuación de ruido 25 dB',   // :contentReference[oaicite:10]{index=10}
            'Baterías Li-Po IP67 de alta capacidad',   // :contentReference[oaicite:11]{index=11}
          ],
        },
      },
      {
        value: 'equipos-poc',
        label: 'Equipos POC',
        categoria_id: 9,
        img: 'https://img-cdn.hytera.com/es_PE/iwov-resources/hytera/02_products/11_landing_page/en_banner_poc_radios.jpg_n.webp',
        info: {
          title: 'Radios POC (Push-To-Talk over Cellular)',
          description:
            'PTT “sin límites” sobre redes 4G/5G y Wi-Fi: ideal para logística, seguridad privada y coordinación a nivel nacional.',
          bullets: [
            'Cobertura LTE + Wi-Fi con itinerancia automática',   // :contentReference[oaicite:12]{index=12}
            'Dual SIM, GPS y mensajería multimedia',   // :contentReference[oaicite:13]{index=13}
            'Batería 4 000 mAh hasta 48 h de servicio',   // :contentReference[oaicite:14]{index=14}
          ],
        },
      },
      {
        value: 'bodycams',
        label: 'Bodycams',
        categoria_id: 10,
        img: 'https://www.sirtelecom.cl/new/wp-content/uploads/2024/08/Final_img_seguridad_bodycam_landing-scaled.jpg',
        info: {
          title: 'Bodycams y evidencia digital',
          description:
            'Captura, transmite y protege cada detalle de tus operaciones con cámaras corporales de alto desempeño.',
          bullets: [
            'Video HD 1080p y streaming 4G/Wi-Fi en tiempo real',   // :contentReference[oaicite:15]{index=15}
            'Cámara rotatoria 216° con visión nocturna',   // :contentReference[oaicite:16]{index=16}
            'Cifrado AES-256 y batería para 11 h de grabación',   // :contentReference[oaicite:17]{index=17}
          ],
        },
      },
    ],
  },
];

function CategoriaInfo({ info, img }) {
  if (!info) return null;

  return (
    <section
      className="relative my-12 h-64 sm:h-72 rounded-2xl overflow-hidden shadow-lg group"
    >
      {/* imagen de fondo */}
      <img
        src={img}
        alt={info.title}
        className="absolute inset-0 w-full h-full object-cover
                   transition duration-500 group-hover:scale-105
                   filter brightness-75 group-hover:brightness-60"
      />

      {/* capa oscura con degradado */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/20 mix-blend-multiply" />

      {/* contenido */}
      <div className="relative z-10 h-full flex flex-col justify-center p-6 text-white">
        <h2 className="text-2xl font-bold mb-2 drop-shadow-md">
          {info.title}
        </h2>

        {info.description && (
          <p className="mb-4 max-w-prose text-sm sm:text-base">
            {info.description}
          </p>
        )}

        {info.bullets?.length > 0 && (
          <ul className="text-sm sm:text-base space-y-1 list-disc list-inside">
            {info.bullets.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}


export default function Productos() {
  const { categoria } = useParams(); // /productos/:categoria?
  const navigate = useNavigate();

  /* Estado de filtros (solo 1 activo, según la URL) */
  const [selectedFilters, setSelectedFilters] = useState([]);

  /* Localiza la opción de categoría activa para mostrar su info */
  const section = filters[0];
  const categoriaObj = section.options.find((o) => o.value === categoria);

  /* Navega y actualiza la categoría activa (desktop) */
  const handleCategoriaClick = (option) => {
    if (categoria === option.value) return;
    navigate(`/productos/${option.value}`);
  };

  /* Al cambiar la ruta, sincroniza selectedFilters */
  useEffect(() => {
    if (!categoria) return;

    const option = section.options.find((o) => o.value === categoria);

    if (option) {
      setSelectedFilters([
        {
          id: section.id,
          values: [{ value: option.value, categoria_id: option.categoria_id }],
        },
      ]);
    }
  }, [categoria]);

  /* ---------- UI ---------- */
  return (
    <div className="bg-white">
      {/* ---------- Banner ---------- */}
      <div className="w-full group h-32 md:h-56 p-6 flex justify-center items-end bg-gray-100 relative overflow-hidden">
        <h1 className="z-10 text-xl sm:text-2xl md:text-4xl lg:text-5xl font-extrabold text-white font-sans group-hover:-translate-y-3 transition duration-500 ease-in-out">
          NUESTROS PRODUCTOS HYTERA
        </h1>
        <img
          src="https://img-cdn.hytera.com/iwov-resources/hytera/02_products/11_landing_page/en_subpage_banner_DMR_Radios.jpg_n.webp"
          alt="Banner Andes-TEC"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-purple-950 opacity-70" />
      </div>

      {/* ---------- Contenido principal ---------- */}
      <main className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* FILTROS DESKTOP – BOTONES */}
        <div className="hidden lg:flex flex-wrap gap-4 pt-10">
          {section.options.map((option) => {
            const activo = categoria === option.value;
            return (
              <button
                type="button"
                key={option.value}
                onClick={() => handleCategoriaClick(option)}
                className={
                  `group relative overflow-hidden rounded-lg border-2 shadow-md py-4 px-4 flex items-center justify-center transition-all duration-200 ${activo ? 'border-purple-700 ring-2 ring-purple-700' : 'border-gray-200'}`
                }
              >
                <img
                  src={option.img}
                  alt={option.label}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <span
                  className={
                    `absolute inset-0 ${activo ? 'bg-black opacity-70' : 'bg-blue-950 opacity-60'} group-hover:bg-black group-hover:opacity-80 transition-all duration-200`
                  }
                />
                <span className="relative z-10 text-white font-semibold text-center uppercase">
                  {option.label}
                </span>
              </button>
            );
          })}
        </div>

        {/* Información contextual de la categoría */}
        <CategoriaInfo info={categoriaObj?.info} img={categoriaObj?.img} />

        {/* GRID DE PRODUCTOS */}
        <ListadoProductos selectedFilters={selectedFilters} vista="grid" />
      </main>
    </div>
  );
}
